<template>
    <main class="SectionLogin-MAIN">
        <img src="../assets/arrow-back.png" @click="$router.push('/');"/>
        <h1>Inicio de sesión</h1>
        <hr>
        <p>
            Ingrese sus datos para acceder a su cuenta.
        </p>

        <b>Correo:</b>
        <input type="email" placeholder="correo@dominio.com" v-model="email" :disabled="loading"/>
        <b>Contraseña:</b>
        <input type="password" placeholder="********" v-model="password" :disabled="loading"/>

        <p class="forgot-pass">¿Olvidó su contraseña?</p>
        <p class="register-btn" @click="$router.push('/register');">Registrarse</p>
        <p class="error-msg" v-if="errorMsg">{{ errorMsg }}</p>

        <button @click="login()" :disabled="loading">ENTRAR</button>
    </main>
</template>

<script>
export default {
    name: 'SectionLogin',
    data(){
        return{
            email: '',
            password: '',
            loading: false,
            errorMsg: '',
        }
    },
    methods: {
        getAuthHeaders() {
            return {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            };
        },

        async login() {
            this.loading = true;
            this.errorMsg = '';
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/login.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        email: this.email,
                        password: this.password
                    })
                });
                const result = await response.json();

                if(result.status == 'success') {
                    const userData = result.user;
                    const DataUsageWarning = JSON.parse(localStorage.getItem('userData'));
                    userData.dataUsageAccepted = DataUsageWarning.dataUsageAccepted;
                    
                    localStorage.setItem('token', result.token);
                    localStorage.setItem( 'userData', JSON.stringify(userData));
                    this.$router.push('/');
                    console.log("Login correcto");
                } else {
                    console.log(result.message);
                    this.errorMsg = result.message;
                }
            } catch(error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        }
        
    }
}
</script>

<style scoped lang="stylus">
.SectionLogin-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: white

    >img
        width: 8vw
        margin-bottom: 2vw

    >h1
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 12vw
        text-wrap: balance
        margin-bottom: 0

    >hr
        width: 100%
        border: 1px solid black

    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6vw
        color: #B0B0B0
        margin-bottom: 8vh

        >span
            color: black
            text-decoration: underline

     >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none

    /* inputs */
    >b
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 6.5vw
        text-transform: uppercase
        color: black

    >input
        font-family: "Archivo ExtraCondensed", sans-serif
        padding: 2vw 0
        margin-bottom: 4vh
        border: none
        border-bottom: 1px solid black
        font-size: 5vw

        &::placeholder
            color: #C3C3C3
            font-size: 6vw

    .forgot-pass
    .register-btn
    .error-msg
        color: rgb(1, 90, 255)
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        font-size: 4.4vw
        margin-top: calc(-4vh + 30px)
        margin-bottom: 0

    .register-btn
    .error-msg
        margin-top: 20px !important

    .error-msg
        color: red
            
</style>